export const FUNCTION_BASE = "https://adsoar.cc";
